import app from '@frontend/application-container';
import { defineComponent, h } from 'vue';
import BarButton from '@components/bar-button';
import { img } from '@phi/components';
import { CurvatureCombIcon } from '../curvature-comb-icon';
import {
    toggle_edge_curvatures,
    showing_curvature_combs,
    ToggleCurvatureCombsTooltip,
} from '@features/curvature-combs';
import { coming_soon } from '@components/icons';

export const ToggleCurvatureCombsButton = defineComponent({
    setup() {
        return () => h(BarButton, {
            disabled: !app.state.loaded,
            active: showing_curvature_combs.value,
            id: 'toggle-curvature-combs-button',
            tippy: 'right',
            onClick: toggle_edge_curvatures,
        }, {
            icon: () => app.state.loaded
                ? img(CurvatureCombIcon)
                : coming_soon(),
            tooltip: ToggleCurvatureCombsTooltip,
        });
    }
});
